import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Link, Navigate, Route, Routes, useLocation } from "react-router-dom";
import AdminPanel from "./pages/AdminPanel";
import LeadsView from "./pages/LeadsView";
import RunsHistory from "./pages/RunsHistory";
const TABS = [
    { to: "/admin", label: "Engines" },
    { to: "/leads", label: "Leads" },
    { to: "/runs", label: "Runs" },
];
function NavBar() {
    const { pathname } = useLocation();
    return (_jsx("nav", { className: "sticky top-0 z-10 border-b bg-white/80 backdrop-blur", children: _jsxs("div", { className: "mx-auto flex max-w-6xl items-center justify-between px-4 py-3 sm:px-6", children: [_jsx(Link, { to: "/admin", className: "text-lg font-bold tracking-tight", children: "LeadGen Engine" }), _jsx("ul", { className: "flex gap-1", children: TABS.map((t) => {
                        const active = pathname.startsWith(t.to);
                        return (_jsx("li", { children: _jsx(Link, { to: t.to, className: `rounded-lg px-3 py-1.5 text-sm transition ${active ? "bg-slate-900 text-white" : "text-slate-700 hover:bg-slate-100"}`, children: t.label }) }, t.to));
                    }) })] }) }));
}
export default function App() {
    return (_jsxs(_Fragment, { children: [_jsx(NavBar, {}), _jsx("main", { children: _jsxs(Routes, { children: [_jsx(Route, { path: "/", element: _jsx(Navigate, { to: "/admin", replace: true }) }), _jsx(Route, { path: "/admin", element: _jsx(AdminPanel, {}) }), _jsx(Route, { path: "/leads", element: _jsx(LeadsView, {}) }), _jsx(Route, { path: "/runs", element: _jsx(RunsHistory, {}) })] }) })] }));
}
